module.exports = __webpack_public_path__ + "static/media/sopt2kz.458806fd.pdf";